import React from 'react'
import DetailAmenities from '@components/amenitiesDetail/1'
import { RealEstateDataPageComponentData } from 'types'
import { title } from 'process'
//Helpers
const developmentAmenities = ({
  propertyID,
  developmentID,
  global_data,
  is_short,
  titlesAmenities,
  alignCenter,
  titleSecondary,
}: {
  propertyID: string
  developmentID: string
} & RealEstateDataPageComponentData) => {
  return (
    <DetailAmenities
      developmentID={developmentID}
      propertyID={propertyID}
      global_data={global_data}
      is_short={is_short}
      titlesAmenities={titlesAmenities}
      alignCenter={alignCenter}
      titleSecondary={titleSecondary}
    />
  )
}

export default developmentAmenities
